import { atom } from 'recoil';

export const roomAtom = atom({
  key: 'ROOM_ATOM',
  default: {
    roomId: null,
    leftRoom: null,
  },
});
